// extracted by mini-css-extract-plugin
export var DarkMode = "Heading-module--DarkMode--da165";
export var Wrapper = "Heading-module--Wrapper--b0ae4";